import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';

import {
  BannerWrapper,
  BannerParagraphContainer,
  BannerHeadingContainer,
  BannerSectionHeader
} from './banner.resourceCenter.styles';

interface BannerAboutProps {
  title: string;
  description: string;
}

const BannerResourceCenter = (props: BannerAboutProps): JSX.Element => {

  return (
    <BannerSectionHeader>
      <FadeInAnimationWrapper>
        <BannerWrapper>
          <BannerHeadingContainer>
            <Heading
              text={props.title}
              size="3.25em"
              sizeSm="2.25em"
              align="center"
            />
          </BannerHeadingContainer>
          <BannerParagraphContainer>
            <Paragraph
              text={props.description}
              size="1.5em"
              sizeSm="1.25em"
              weight="light"
              align="center"
            />
          </BannerParagraphContainer>
        </BannerWrapper>
      </FadeInAnimationWrapper>
    </BannerSectionHeader>
  )
}

export default BannerResourceCenter;
